
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { TableThingyActions } from "../actions/table_actions";
import {licensedata} from "../typing/table_typing";
import { myfetchThunk } from "../../../app/myfetch";
import {masteruri} from "../../../config";
import { message } from "antd";
import { BulkResult, summariseBulk } from "../typing/licence_rows";


interface licenseResponsePayloadInterface{
    data:{
    license:licensedata[],
    }
}

/** The licence list; archived (removed) licences only when asked for (anima_core #8). */
export const requestDataFromAPI =(includeArchived:boolean = false) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/License"+(includeArchived ? "?includeArchived=true" : ""),
            {},
            "GET",
            (payload:licenseResponsePayloadInterface) => {
                dispatch(
                     TableThingyActions.resetData(
                         {
                             license : payload.data.license,
                         }
                     )
                 );
                 console.log(payload);
            },
            ()=>{}
        ) as any)
    }
}

/**
 * Removes a licence (admin only, anima_core #8): the hub archives it - the
 * row stays, the list hides it, activate and verify no longer know it.
 * Since anima_core #7 only an unused one; a licence in use comes back 409.
 * onDone runs after either answer, to reload what is shown.
 */
export const requestRemoveLicence =(uuid:string, inUseText:string, onDone:() => void) => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/License/"+uuid,
            {},
            "DELETE",
            (payload:{status:string}) => {
                message.success(payload?.status ?? "License removed");
                onDone();
            },
            (payload:any) => {
                message.error(payload?.status === 409 ? inUseText : (payload?.message ?? "License not removed."));
                onDone();
            },
        ) as any)
    }
}

/**
 * Removes several licences at once (admin only, anima_core #7). The hub
 * judges each on its own: unused ones are archived, the rest are named.
 * texts formats the summary; onDone runs after either answer.
 */
export const requestRemoveLicences =(
    uuids:string[],
    texts:{ summary:(archived:number, unchanged:number, refused:number) => string, failed:string },
    onDone:() => void,
) => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/License/archive",
            { uuids },
            "POST",
            (payload:{results?:BulkResult[]}) => {
                const sum = summariseBulk(payload?.results);
                (sum.refused > 0 ? message.warning : message.success)(texts.summary(sum.archived, sum.unchanged, sum.refused));
                onDone();
            },
            () => {
                message.error(texts.failed);
                onDone();
            },
        ) as any)
    }
}

/** Brings a removed (archived) licence back (admin only). */
export const requestRestoreLicence =(uuid:string, onDone:() => void) => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/License/"+uuid+"/restore",
            {},
            "POST",
            (payload:{status:string}) => {
                message.success(payload?.status ?? "License restored");
                onDone();
            },
            (payload:any) => {
                message.error(payload?.message ?? "License not restored.");
                onDone();
            },
        ) as any)
    }
}
